module.exports = __webpack_public_path__ + "img/plus-rounded-white-used.cf547fb3.svg";